import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const BASE_URL = import.meta.env.BASE_URL;

export const onLoadLanguages = async () => {
  try {
    console.debug("Loading languages...");
    const loadLanguages = await fetch(`${BASE_URL}/locales/languages.json`);
    const langs = await loadLanguages.json();
    console.debug("Loaded languages", langs);

    return langs;
  } catch (err) {
    console.error(
      "Could not load languages. Falling back to English only.",
      err
    );
    return ["en"];
  }
};

export const initializeI18n = async () => {
  const langs = await onLoadLanguages();

  return i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      supportedLngs: langs,
      backend: {
        loadPath: `${BASE_URL}/locales/{{lng}}/translations.json`,
      },
      interpolation: {
        escapeValue: false,
      },
    });
};

export default i18n;
